import Toast from "../../components/Toast";
import Layout from "../../components/Layout";
import styles from "./CV.module.css"
import projectsData from '../../data/projects.json';
import userData from '../../data/user.json';
import workData from '../../data/work.json';
import ProjectCommitStatus from '../../components/ProjectCommitStatus/ProjectCommitStatus';

export default function CV() {

    const workExperience = workData.experience || [];
    const petProjects = projectsData.projects || [];
    const user = userData;

    return (
        <Layout>
            <div id="cv">
                <div className={styles.mainContainer}>
                    <div className={styles.name}>{user.name}</div>
                    <div className={styles.profession}>{user.profession}</div>

                    <div className={styles.socialContainer}>
                        <a className={styles.socialItem} href={user.github} rel="noopener noreferrer">
                            <div className={`${styles.socialItemImg} ${styles.githubIcon}`} />
                            {user.githubHandle}
                        </a>
                        <a className={styles.socialItem} href={user.telegram} rel="noopener noreferrer">
                            <img className={styles.socialItemImg} src="/social/telegram.png" alt="Telegram" />
                            {user.telegramHandle}
                        </a>
                        <a className={styles.socialItem} href={`mailto:${user.email}`} rel="noopener noreferrer">
                            <div className={`${styles.socialItemImg} ${styles.emailIcon}`} />
                            Email
                        </a>
                    </div>
                </div>

                <div className={styles.infoContainer}>
                    {/* Обо мне */}
                    <div className={styles.aboutMeContainer}>
                        <div className={styles.aboutMeTitle}>Обо мне</div>
                        <div className={styles.bio}>{user.bio}</div>
                    </div>

                    {/* Хард скиллы */}
                    <div className={styles.hardSkillsContainer}>
                        <div className={styles.hardSkillsTitle}>Хард скиллы</div>

                        <div className={styles.skillsWrapper}>
                            {/* Группа: Общие инструменты */}
                            <div className={styles.skillGroup}>
                                <div className={styles.skillGroupTitle}>Инструменты и технологии</div>
                                <div className={styles.skillsList}>
                                    <span className={styles.skillTechTag}>Git</span>
                                    <span className={styles.skillTechTag}>REST API</span>
                                    <span className={styles.skillTechTag}>Docker</span>
                                    <span className={styles.skillTechTag}>JWT</span>
                                    <span className={styles.skillTechTag}>Redis</span>
                                    <span className={styles.skillTechTag}>PostgreSQL</span>
                                    <span className={styles.skillTechTag}>Telegram-боты</span>
                                    <span className={styles.skillTechTag}>Discord-боты</span>
                                    <span className={styles.skillTechTag}>Linux</span>
                                </div>
                            </div>

                            {/* Группа: Java экосистема */}
                            <div className={styles.skillGroup}>
                                <div className={styles.skillGroupTitle}>Java / JVM</div>
                                <div className={styles.skillsList} style={{ marginTop: '8px' }}>
                                    <span className={styles.skillTechTag}>Spring Boot</span>
                                    <span className={styles.skillTechTag}>Gradle</span>
                                    <span className={styles.skillTechTag}>JUnit</span>
                                    <span className={styles.skillTechTag}>Lombok</span>
                                    <span className={styles.skillTechTag}>Log4j</span>
                                </div>
                            </div>

                            {/* Группа: C++ */}
                            <div className={styles.skillGroup}>
                                <div className={styles.skillGroupTitle}>C++20</div>
                                <div className={styles.skillsList} style={{ marginTop: '8px' }}>
                                    <span className={styles.skillTechTag}>Boost.Asio/Beast</span>
                                    <span className={styles.skillTechTag}>STL</span>
                                    <span className={styles.skillTechTag}>CMake</span>
                                </div>
                            </div>

                            {/* Группа: Go */}
                            <div className={styles.skillGroup}>
                                <div className={styles.skillGroupTitle}>Go</div>
                                <div className={styles.skillsList}>
                                    <span className={styles.skillTechTag}>Gin</span>
                                    <span className={styles.skillTechTag}>net/http</span>
                                    <span className={styles.skillTechTag}>testing</span>
                                    <span className={styles.skillTechTag}>goroutines</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Опыт работы */}
                    <div className={styles.experienceContainer}>
                        <div className={styles.experienceTitle}>Опыт работы</div>
                        {workExperience.length > 0 ? (
                            <div className={styles.experienceList}>
                                {workExperience.map((job) => (
                                    <div key={job.id} className={styles.experienceItem}>
                                        <div className={styles.jobHeader}>
                                            <div className={styles.jobMainInfo}>
                                                <h3 className={styles.jobCompany}>{job.company}</h3>
                                                <span className={styles.jobPosition}>{job.position}</span>
                                            </div>
                                            <span className={styles.jobPeriod}>{job.period}</span>
                                        </div>
                                        <p className={styles.jobDescription}>{job.description}</p>
                                        {job.tech && job.tech.length > 0 && (
                                            <div className={styles.jobTech}>
                                                {job.tech.map((technology, idx) => (
                                                    <span key={idx} className={styles.techTag}>{technology}</span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className={styles.noExperience}>
                                <div className={styles.noExperienceIcon}>🚀</div>
                                <p className={styles.noExperienceDescription}>
                                    Пока нет коммерческого опыта, но есть огромное желание развиваться!
                                </p>
                                <a href={`mailto:${user.email}`} className={styles.noExperienceHighlight}>
                                    Вы можете стать моим первым работодателем!
                                </a>
                            </div>
                        )}
                    </div>

                    {/* Личные проекты */}
                    <div className={styles.petProjectsContainer}>
                        <div className={styles.petProjectsTitle}>Личные проекты</div>
                        {petProjects.length > 0 ? (
                            <div className={styles.projectsGrid}>
                                {petProjects.map((project) => (
                                    <div key={project.id} className={styles.projectCard}>
                                        <h3 className={styles.projectName}>{project.name}</h3>

                                        <div className={styles.techStack}>
                                            {project.tech.map((technology, idx) => (
                                                <span key={idx} className={styles.techTag}>{technology}</span>
                                            ))}
                                        </div>

                                        <p className={styles.projectDescription}>{project.description}</p>

                                        <div className={styles.projectFooter}>
                                            <div className={styles.projectLinks}>
                                                {project.links.map((link, idx) => (
                                                    <a
                                                        key={idx}
                                                        href={link.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className={`${styles.projectLink} ${styles[link.type]}`}
                                                    >
                                                        <span>{link.label}</span>
                                                    </a>
                                                ))}
                                            </div>

                                            {/* Используем компонент ProjectCommitStatus */}
                                            <ProjectCommitStatus
                                                status={project.status}
                                                statusType={project.statusType}
                                                githubOwner={project.githubOwner}
                                                repoName={project.repoName}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className={styles.emptyState}>
                                <div className={styles.emptyIcon}>📂</div>
                                <h4 className={styles.emptyTitle}>Проекты пока отсутствуют</h4>
                                <p className={styles.emptyText}>
                                    Сейчас активно работаю над новыми идеями и проектами
                                </p>
                            </div>
                        )}
                    </div>
                    {/* <div className={styles.petProjectsContainer}>
                        <div className={styles.petProjectsTitle}>Личные проекты</div>
                        {petProjects.length > 0 ? (
                            <div className={styles.projectsGrid}>
                                {petProjects.map((project) => (
                                    <div key={project.id} className={styles.projectCard}>
                                        <h3 className={styles.projectName}>{project.name}</h3>
                                        <div className={styles.techStack}>
                                            {project.tech.map((technology, idx) => (
                                                <span key={idx} className={styles.techTag}>{technology}</span>
                                            ))}
                                        </div>
                                        <p className={styles.projectDescription}>{project.description}</p>
                                        <div className={styles.projectFooter}>
                                            <div className={styles.projectLinks}>
                                                {project.links.map((link, idx) => (
                                                    <a key={idx} href={link.url} target="_blank" rel="noopener noreferrer"
                                                        className={`${styles.projectLink} ${styles[link.type]}`}>
                                                        <span>{link.label}</span>
                                                    </a>
                                                ))}
                                            </div>
                                            <div className={`${styles.projectStatus} ${styles[project.statusType]}`}>
                                                <span className={styles.statusDot}></span>
                                                <span>{project.status}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className={styles.emptyState}>
                                <div className={styles.emptyIcon}>📂</div>
                                <h4 className={styles.emptyTitle}>Проекты пока отсутствуют</h4>
                                <p className={styles.emptyText}>Сейчас активно работаю над новыми идеями</p>
                            </div>
                        )}
                    </div> */}

                    {/* Языки */}
                    <div className={styles.languageContainer}>
                        <div className={styles.languageTitle}>Владение языками</div>
                        {user.languages.map((lang, idx) => (
                            <div className={styles.langItem}>
                                <img
                                    className={styles.langEmoji}
                                    src={`/flags/${lang.flag}.svg`}
                                    alt={lang.name}
                                />
                                <span className={styles.langName}>{lang.name}</span>
                                <div className={styles.langLine}></div>
                                <span className={styles.langLevel}>{lang.level}</span>
                            </div>
                        ))}
                    </div>

                    {/* Софт скиллы */}
                    <div className={styles.softSkillsContainer}>
                        <div className={styles.softSkillsTitle}>Софт скиллы</div>
                        <div className={styles.softSkillsList}>
                            {user.softSkills.map((skill, idx) => (
                                <div key={idx} className={styles.softSkillsItem}>• {skill}</div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <Toast />
        </Layout>
    );

    // return (
    //     <Layout>
    //         <div id="cv">
    //             {/* ОСНОВНОЙ КОНТЕЙНЕР */}
    //             <div className={styles.mainContainer}>
    //                 <div className={styles.name}>Андрей Барышев</div>
    //                 <div className={styles.profession}>
    //                     Студент 1-го курса. Математика и Компьютерные науки (УрФУ)
    //                 </div>
    //                 <div className={styles.socialContainer}>
    //                     <a className={styles.socialItem} href="https://github.com/Barkosss" rel="noopener noreferrer">
    //                         <div className={`${styles.socialItemImg} ${styles.githubIcon}`}/>
    //                         @Barkosss
    //                     </a>
    //                     <a className={styles.socialItem} href="https://t.me/Barkosss" rel="noopener noreferrer">
    //                         <img
    //                             className={styles.socialItemImg}
    //                             src="/social/telegram.png"
    //                             alt="Telegram"
    //                         />
    //                         t.me/Barkosss
    //                     </a>
    //                     <a className={styles.socialItem} href="mailto:hello@barkos.dev" rel="noopener noreferrer">
    //                         <div className={`${styles.socialItemImg} ${styles.emailIcon}`}/>
    //                         hello@barkos.dev
    //                     </a>
    //                 </div>
    //             </div>

    //             {/* ИНФОРМАЦИОННЫЙ КОНТЕЙНЕР */}
    //             <div className={styles.infoContainer}>

    //                 {/* РАЗДЕЛ "ОБО МНЕ" */}
    //                 <div className={styles.aboutMeContainer}>
    //                     <div className={styles.aboutMeTitle}>Обо мне</div>
    //                     <div className={styles.bio}>
    //                         Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
    //                         been
    //                         the industry's standard dummy text ever since the 1500s, when an unknown printer took a
    //                         galley
    //                         of type and scrambled it to make a type specimen book.
    //                     </div>
    //                 </div>

    //                 {/* РАЗДЕЛ "ХАРД СКИЛЛЫ" */}
    //                 <div className={styles.hardSkillsContainer}>
    //                     <div className={styles.hardSkillsTitle}>Хард скилы</div>
    //                     <div className={styles.hardSkillItem}>Java</div>
    //                     <div className={styles.hardSkillItem}>С++</div>
    //                     <div className={styles.hardSkillItem}>Git</div>
    //                     <div className={styles.hardSkillItem}>Docker</div>
    //                 </div>

    //                 {/* РАЗДЕЛ "ОПЫТ РАБОТЫ" */}
    //                 <div className={styles.experienceContainer}>
    //                     <div className={styles.experienceTitle}>Опыт работы</div>

    //                     {/* Проверка на наличие опыта работы */}
    //                     {workExperience && workExperience.length > 0 ? (
    //                         <div className={styles.experienceList}>
    //                             {workExperience.map((job) => (
    //                                 <div key={job.id} className={styles.experienceItem}>
    //                                     <div className={styles.jobHeader}>
    //                                         <div className={styles.jobMainInfo}>
    //                                             <h3 className={styles.jobCompany}>{job.company}</h3>
    //                                             <span className={styles.jobPosition}>{job.position}</span>
    //                                         </div>
    //                                         <span className={styles.jobPeriod}>{job.period}</span>
    //                                     </div>

    //                                     <p className={styles.jobDescription}>
    //                                         {job.description}
    //                                     </p>

    //                                     {job.tech && job.tech.length > 0 && (
    //                                         <div className={styles.jobTech}>
    //                                             {job.tech.map((technology, index) => (
    //                                                 <span key={index} className={styles.techTag}>
    //                                 {technology}
    //                             </span>
    //                                             ))}
    //                                         </div>
    //                                     )}
    //                                 </div>
    //                             ))}
    //                         </div>
    //                     ) : (
    //                         <div className={styles.noExperience}>
    //                             <div className={styles.noExperienceIcon}>🚀</div>
    //                             <p className={styles.noExperienceDescription}>
    //                                 Пока нет коммерческого опыта, но есть огромное желание развиваться!
    //                             </p>
    //                             <Link to="mailto:hello@barkos.dev">
    //                                 <div className={styles.noExperienceHighlight}>
    //                                     Вы можете стать моим первым работодателем!
    //                                 </div>
    //                             </Link>
    //                         </div>
    //                     )}
    //                 </div>

    //                 {/* РАЗДЕЛ "ЛИЧНЫЕ ПРОЕКТЫ" */}
    //                 <div className={styles.petProjectsContainer}>
    //                     <div className={styles.petProjectsTitle}>Личные проекты</div>

    //                     {/* Проверка на наличие проектов */}
    //                     {petProjects && petProjects.length > 0 ? (
    //                         <div className={styles.projectsGrid}>
    //                             {petProjects.map((project) => (
    //                                 <div key={project.id} className={styles.projectCard}>
    //                                     <h3 className={styles.projectName}>{project.name}</h3>

    //                                     <div className={styles.techStack}>
    //                                         {project.tech.map((technology, index) => (
    //                                             <span key={index} className={styles.techTag}>
    //                             {technology}
    //                         </span>
    //                                         ))}
    //                                     </div>

    //                                     <p className={styles.projectDescription}>
    //                                         {project.description}
    //                                     </p>

    //                                     {/* Футер со ссылками и статусом */}
    //                                     <div className={styles.projectFooter}>

    //                                         {/* Ссылки справа */}
    //                                         <div className={styles.projectLinks}>
    //                                             {project.links.map((link, index) => (
    //                                                 <a
    //                                                     key={index}
    //                                                     href={link.url}
    //                                                     target="_blank"
    //                                                     rel="noopener noreferrer"
    //                                                     className={`${styles.projectLink} ${styles[link.type]}`}
    //                                                 >
    //                                                     <div
    //                                                         className={`${styles.socialItemImg} ${styles.githubIcon}`}/>
    //                                                     <span>{link.label}</span>
    //                                                 </a>
    //                                             ))}
    //                                         </div>

    //                                         {/* Статус слева */}
    //                                         <div className={`${styles.projectStatus} ${styles[project.statusType]}`}>
    //                                             <span className={styles.statusDot}></span>
    //                                             <span>{project.status}</span>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             ))}
    //                         </div>
    //                     ) : (
    //                         <div className={styles.emptyState}>
    //                             <div className={styles.emptyIcon}>📂</div>
    //                             <h4 className={styles.emptyTitle}>Проекты пока отсутствуют</h4>
    //                             <p className={styles.emptyText}>
    //                                 Сейчас активно работаю над новыми идеями и проектами<br/>
    //                             </p>
    //                         </div>
    //                     )}
    //                 </div>

    //                 {/* РАЗДЕЛ "ВЛАДЕНИЕ ЯЗЫКАМИ" */}
    //                 <div className={styles.languageContainer}>
    //                     <div className={styles.languageTitle}>Владение языками</div>
    //                     <div className={styles.langItem}>
    //                         <img className={styles.langEmoji} src="https://emojicdn.elk.sh/🇷🇺" alt="🇷🇺"/>{' '}
    //                         <span className={styles.langName}>Русский</span>
    //                         <div className={styles.langLine}></div>
    //                         <span className={styles.langLevel}>Родной</span>
    //                     </div>

    //                     <div className={styles.langItem}>
    //                         <img className={styles.langEmoji} src="https://emojicdn.elk.sh/🇬🇧" alt="🇬🇧"/>
    //                         <span className={styles.langName}>Английский</span>
    //                         <div className={styles.langLine}></div>
    //                         <span className={styles.langLevel}>A2 – Pre-Intermediate</span>
    //                     </div>
    //                 </div>

    //                 {/* РАЗДЕЛ "СОФТ СКИЛЛЫ" */}
    //                 <div className={styles.softSkillsContainer}>
    //                     <div className={styles.softSkillsTitle}>Софт скилы</div>
    //                     <div className={styles.softSkillsItem}>
    //                         Открыт к критике, умею гуглить и искать информацию
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>

    //         {/* КНОПКА СКАЧАТЬ РЕЗЮМЕ В PDF */}
    //         {/* <button onClick={handlePrint} className={styles.downloadCV}>
    //             📄 Скачать PDF
    //         </button> */}
    //         <Toast/>
    //     </Layout>
    // );
}